// Custom hook for fetching chat data
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  getChatByParticipantRequest,
  sendMessageByParticipantRequest,
} from 'api';
import { useAuth } from 'context/AuthContext';

const fetchChatByParticipant = async (chatId: number) => {
  const response = await getChatByParticipantRequest(chatId);
  if (response.status !== 200) {
    throw new Error('Error fetching chat');
  }
  return response.data;
};

// Custom hook for sending message
const sendMessage = async (chatId: number, message: string) => {
  const response = await sendMessageByParticipantRequest(chatId, {
    text: message,
  });
  if (!response.data) {
    throw new Error('Error sending message');
  }
  return response.data;
};

function useChats(chatId?: number | undefined | null) {
  const { isAuthenticated } = useAuth();

  const queryClient = useQueryClient();
  const {
    data: chat,
    error: chatError,
    isLoading: chatIsLoading,
    isLoading: chatIsFetching,
    isFetched: chatIsFetched,
    isError: chatIsError,
    isLoadingError: chatIsLoadingError,
    isSuccess: chatIsSuccess,
    refetch: chatRefetch,
    isPending: chatIsPending,
  } = useQuery({
    queryKey: ['chat', chatId],
    queryFn: () => {
      if (!chatId) {
        return Promise.reject(new Error('Invalid chatId'));
      }
      return fetchChatByParticipant(chatId!);
    },
    enabled: !!chatId && isAuthenticated,
  });

  // React Query hook to send a new message
  const { mutate, isPending } = useMutation({
    mutationFn: ({
      recipientId,
      message,
    }: {
      recipientId: number;
      message: string;
    }) => sendMessage(recipientId, message),
    onSuccess: (newMessage) => {
      if (chat) {
        // chatRefetch();
        queryClient.invalidateQueries({ queryKey: ['chat', chatId] });
      }
    },
  });
  //
  // console.log(
  //   'chatError',
  //   chatError,
  //   'chatIsFetched',
  //   chatIsFetched,
  //   'chatIsError',
  //   chatIsError,
  //   'chatIsLoadingError',
  //   chatIsLoadingError,
  //   'chatIsSuccess',
  //   chatIsSuccess,
  //   'chatIsLoading',
  //   chatIsLoading,
  //   'chatIsFetching',
  //   chatIsFetching,
  //   'isPending',
  //   isPending,
  // );

  return {
    chat,
    chatError,
    chatIsLoading,
    chatIsFetching,
    chatIsFetched,
    chatIsError,
    chatIsLoadingError,
    chatIsSuccess,
    chatRefetch,
    sendMessage: mutate,
    isPending: chatIsPending || isPending,
  };
}

export default useChats;
